import { render, staticRenderFns } from "./SeguimientoNovedades.vue?vue&type=template&id=41231cc3"
import script from "./SeguimientoNovedades.vue?vue&type=script&lang=js"
export * from "./SeguimientoNovedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports